import React, { useEffect, useState, useRef } from 'react';
// import './Header.css';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import KeyRegCards_FPS_Cards from './KeyRegCards_FPS_Cards';

const KeyRegisterAllotFPS_data = async (parms) => {
    const response = await fetch(`${process.env.REACT_APP_URL_ALLOTMENT}/KeyRegister/getfpsKeyRegisterCards`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(parms),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};
const KeyRegCards_FPS = ({ month, year, dist_code, afso_code }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const fpstab = useRef(null); // Use ref to scroll to this div
    const [renderContenttttt, setRenderContenttttt] = useState(null);
    const details3 = useRef(null); // Use ref to scroll to this div
    const [nfsaSchemeList, setNfsaSchemeList] = useState([]);
    const [stateSchemeList, setStateSchemeList] = useState([]);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null);

    const handleFPSClick = (month, year, dist_code, afso_code, fps_id) => {

        setRenderContenttttt(null);

        setTimeout(() => {
            setRenderContenttttt(
                <KeyRegCards_FPS_Cards
                    month={month}
                    year={year}
                    dist_code={dist_code}
                    afso_code={afso_code}
                    fps_id={fps_id}
                />
            );
        }, 10);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotFPS_data({ month, year, dist_code, afso_code });
                setTabHeading(response_data.heading);

                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (errorr) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, dist_code, afso_code]);


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotFPS_data({ month, year, dist_code, afso_code });
                setTabHeading(response_data.heading);

                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);

                    const nfsa = [];
                    const state = [];

                    // FIXED: schemelist -> schemeWrapperList
                    response_data.data.forEach(item => {
                        (item.schemeWrapperList || []).forEach(scheme => {
                            if (scheme.nfsaSchemeList) nfsa.push(...scheme.nfsaSchemeList);
                            if (scheme.stateSchemeList) state.push(...scheme.stateSchemeList);
                        });
                    });

                    const uniqueNfsa = Array.from(new Map(nfsa.map(s => [s.scheme_id, s])).values());
                    const uniqueState = Array.from(new Map(state.map(s => [s.scheme_id, s])).values());

                    setNfsaSchemeList(uniqueNfsa);
                    setStateSchemeList(uniqueState);
                } else {
                    setReportData([]);
                    setNfsaSchemeList([]);
                    setStateSchemeList([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, dist_code, afso_code]);

    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);

    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ display: 'flex' }}><CircularProgress /></Box>
        </div>
    );

    if (error) return <div className="mainhead" align="center">Internal Error</div>;
    if (!reportData || reportData.length === 0) return <div className="mainhead" align="center">No data found</div>;

    const allSchemes = [...nfsaSchemeList, ...stateSchemeList];

    const totals = {
        total_shops: 0,
        total_cards: 0,
        total_units: 0,
        schemes: {}
    };

    allSchemes.forEach(s => {
        totals.schemes[s.scheme_id] = { cards: 0, units: 0 };
    });

    // FIXED LOOP — USE schemeWrapperList
    reportData.forEach(item => {
        totals.total_shops += item.total_shops || 0;
        totals.total_cards += item.total_cards || 0;
        totals.total_units += item.total_units || 0;

        allSchemes.forEach(scheme => {
            let data = { cards: 0, units: 0 };

            (item.schemeWrapperList || []).forEach(s => {
                const nf = (s.nfsaSchemeList || []).find(n => n.scheme_id === scheme.scheme_id);
                const st = (s.stateSchemeList || []).find(n => n.scheme_id === scheme.scheme_id);

                if (nf) data = nf;
                if (st) data = st;
            });

            totals.schemes[scheme.scheme_id].cards += data.cards;
            totals.schemes[scheme.scheme_id].units += data.units;
        });
    });

    return (
        <>
            <table id="myTable" align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={allSchemes.length * 2 + 5}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>FPS</th>
                        <th rowSpan={3}>Dealer Name</th>
                        <th rowSpan={3}>Total <br /> Cards</th>
                        <th rowSpan={3}>Total <br /> Units</th>
                        {nfsaSchemeList?.length > 0 && (
                            <th colSpan={nfsaSchemeList.length * 2}>NFSA</th>
                        )}

                        {stateSchemeList?.length > 0 && (
                            <th colSpan={stateSchemeList.length * 2}>Non-NFSA</th>
                        )}
                    </tr>
                    <tr className="tableheader">
                        {nfsaSchemeList.map((s, i) => <th colSpan={2} key={i}>{s.scheme_short_name}</th>)}
                        {stateSchemeList.map((s, i) => <th colSpan={2} key={'s' + i}>{s.scheme_short_name}</th>)}
                    </tr>
                    <tr className="tableheader">
                        {allSchemes.map((s, i) => (
                            <React.Fragment key={i}>
                                <th>Cards</th>
                                <th>Units</th>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.dist_Code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                                <a style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={() => handleFPSClick(month, year, item.dist_Code, item.afso_code, item.fps_id)}>
                                    {item.fps_id}
                                </a>
                            </td>
                            <td style={{ textAlign: 'left' }}>{item.del_name}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_units}</td>

                            {allSchemes.map((scheme, i) => {
                                let data = { cards: 0, units: 0 };

                                (item.schemeWrapperList || []).forEach(s => {
                                    const nf = (s.nfsaSchemeList || []).find(n => n.scheme_id === scheme.scheme_id);
                                    const st = (s.stateSchemeList || []).find(n => n.scheme_id === scheme.scheme_id);

                                    if (nf) data = nf;
                                    if (st) data = st;
                                });

                                return (
                                    <React.Fragment key={i}>
                                        <td style={{ textAlign: 'right' }}>{data.cards}</td>
                                        <td style={{ textAlign: 'right' }}>{data.units}</td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                    ))}

                    <tr className="tableheader">
                        <td colSpan={3} style={{ textAlign: 'center' }}>Total</td>
                        <td style={{ textAlign: 'right' }}>{totals.total_cards}</td>
                        <td style={{ textAlign: 'right' }}>{totals.total_units}</td>
                        {allSchemes.map((scheme, i) => (
                            <React.Fragment key={i}>
                                <td style={{ textAlign: 'right' }}>{totals.schemes[scheme.scheme_id].cards}</td>
                                <td style={{ textAlign: 'right' }}>{totals.schemes[scheme.scheme_id].units}</td>
                            </React.Fragment>
                        ))}
                    </tr>

                    <tr className="tableheader">
                        <th colSpan={allSchemes.length * 2 + 5} style={{ textAlign: 'right' }}>
                            Data Time: {reportData[0].update_time.substring(0, 16)}
                        </th>
                    </tr>
                </tbody>
            </table>

            <br /><br />

            <div id="detailsERR" ref={detailsRRef}>{renderContenttttt}</div>
        </>
    );
};
export default KeyRegCards_FPS;
